module.exports = "<div #pie class=\"pie\" [style.background-image]=\"backgroundImage\">\r\n  <div class=\"mask\" [style.background]=\"applyColor ? chartBgColor : 'white'\" [style.transform]=\"deg\"></div>\r\n  <div class='pie-data centralise-element large'>\r\n      <div class=\"centralise-element\">\r\n          <span [style.color]=\"chartLabelColor\" class=\"bold-text\">{{workDonePerc}}</span>\r\n      </div>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/pie-chart/pie-chart.component.html
// module id = ../../../../../src/app/core/components/pie-chart/pie-chart.component.html
// module chunks = main